import { useProfilePreview } from "PFApp/use_profile_preview";
import { Card } from "PFComponents/card";
import { getProfileName } from "PFCore/helpers/profile";
import { Profile, ProfileSearchHighlights } from "PFTypes";
import { RefObject, useCallback } from "react";

import { ProfileCardContent } from "./parts";

export type ProfileCardProps = {
  profile: Profile;
  highlights?: ProfileSearchHighlights;
  scrollableContainerRef?: RefObject<HTMLDivElement | null>;
};

export const ProfileCard = ({ profile, ...props }: ProfileCardProps) => {
  const { showPreview } = useProfilePreview();

  const profileName = getProfileName(profile);

  const onCardClick = useCallback(() => {
    showPreview({ id: profile.id, profile });
  }, [profile, showPreview]);

  return (
    <Card onClick={onCardClick} ariaLabel={profileName}>
      <ProfileCardContent profile={profile} {...props} />
    </Card>
  );
};
